document.addEventListener('DOMContentLoaded', function() {
  // 确保页面初始状态正常
  document.body.classList.remove('dropdown-open');
  
  // 获取所有导航项
  const navItems = document.querySelectorAll('.mt-navigation__nav-item');
  
  // 全局状态管理
  let currentDropdown = null;
  let dropdownTimeout = null;
  let isMouseInDropdown = false;
  let isMouseInNavItem = false;
  let lastHoveredItem = null;
  let hoverTimeout = null;
  let isTransitioning = false;
  let transitionTimeout = null;
  
  // 重置状态函数
  function resetState() {
    currentDropdown = null;
    isMouseInDropdown = false;
    isMouseInNavItem = false;
    lastHoveredItem = null;
    // 确保body状态正常
    document.body.classList.remove('dropdown-open');
  }
  
  // 清除定时器函数
  function clearAllTimeouts() {
    if (hoverTimeout) {
      clearTimeout(hoverTimeout);
      hoverTimeout = null;
    }
    if (dropdownTimeout) {
      clearTimeout(dropdownTimeout);
      dropdownTimeout = null;
    }
    if (transitionTimeout) {
      clearTimeout(transitionTimeout);
      transitionTimeout = null;
    }
  }
  
  // 显示下拉菜单的函数
  function showDropdown(dropdown, item) {
    
    // 如果正在过渡中，但目标是同一个下拉菜单，允许显示
    if (isTransitioning && currentDropdown === dropdown) {
      return;
    }
    
    // 如果正在过渡中，但目标是不同的下拉菜单，强制重置状态
    if (isTransitioning && currentDropdown !== dropdown) {
      isTransitioning = false;
      clearTimeout(transitionTimeout);
    }
    
    clearTimeout(transitionTimeout);
    isTransitioning = true;
    
    // 确保所有其他下拉菜单都被隐藏
    const allDropdowns = document.querySelectorAll('.mt-navigation__dropdown');
    allDropdowns.forEach(d => {
      if (d !== dropdown) {
        d.style.opacity = '0';
        d.style.visibility = 'hidden';
        d.style.transform = 'translateY(-106px)';
        const otherItem = d.closest('.mt-navigation__nav-item');
        if (otherItem) {
          otherItem.classList.remove('dropdown-open');
          const otherNavLink = otherItem.querySelector('.mt-navigation__nav-link');
          if (otherNavLink) {
            otherNavLink.classList.remove('mt-navigation__nav-link--hover');
          }
        }
      }
    });
    
    dropdown.style.opacity = '1';
    dropdown.style.visibility = 'visible';
    dropdown.style.transform = 'translateY(0)';
    document.body.classList.add('dropdown-open');
    item.classList.add('dropdown-open');
    
    // 确保一级菜单下划线显示
    const navLink = item.querySelector('.mt-navigation__nav-link');
    if (navLink) {
      navLink.classList.add('mt-navigation__nav-link--hover');
    }
    
    // 设置过渡完成后的状态
    transitionTimeout = setTimeout(() => {
      isTransitioning = false;
    }, 400);
  }
  
  // 隐藏下拉菜单的函数
  function hideDropdown(dropdown, item) {
    
    // 如果正在过渡中，但目标是同一个下拉菜单，允许隐藏
    if (isTransitioning && currentDropdown === dropdown) {
      return;
    }
    
    // 如果正在过渡中，但目标是不同的下拉菜单，强制重置状态
    if (isTransitioning && currentDropdown !== dropdown) {
      isTransitioning = false;
      clearTimeout(transitionTimeout);
    }
    
    clearTimeout(transitionTimeout);
    isTransitioning = true;
    
    dropdown.style.opacity = '0';
    dropdown.style.visibility = 'hidden';
    dropdown.style.transform = 'translateY(-106px)';
    document.body.classList.remove('dropdown-open');
    item.classList.remove('dropdown-open');
    
    // 移除一级菜单下划线
    const navLink = item.querySelector('.mt-navigation__nav-link');
    if (navLink) {
      navLink.classList.remove('mt-navigation__nav-link--hover');
    }
    
    // 设置过渡完成后的状态
    transitionTimeout = setTimeout(() => {
      isTransitioning = false;
    }, 400);
  }
  
  // 强制隐藏所有下拉菜单的函数
  function hideAllDropdowns() {
    // 强制重置过渡状态
    isTransitioning = false;
    clearTimeout(transitionTimeout);
    
    navItems.forEach(item => {
      const dropdown = item.querySelector('.mt-navigation__dropdown');
      if (dropdown) {
        // 立即隐藏下拉菜单
        dropdown.style.opacity = '0';
        dropdown.style.visibility = 'hidden';
        dropdown.style.transform = 'translateY(-106px)';
        item.classList.remove('dropdown-open');
        
        const navLink = item.querySelector('.mt-navigation__nav-link');
        if (navLink) {
          navLink.classList.remove('mt-navigation__nav-link--hover');
        }
      }
    });
    
    // 重置全局状态
    currentDropdown = null;
    isMouseInDropdown = false;
    isMouseInNavItem = false;
    lastHoveredItem = null;
    document.body.classList.remove('dropdown-open');
  }
  
  // 检查鼠标是否移动到导航相关元素
  function isMouseInNavigationElement(relatedTarget) {
    return relatedTarget && (
      relatedTarget.closest('.mt-navigation__dropdown') ||
      relatedTarget.closest('.mt-navigation__nav-item') ||
      relatedTarget.closest('.mt-navigation__dropdown-container') ||
      relatedTarget.closest('.mt-navigation__header') ||
      relatedTarget.closest('.mt-navigation__container')
    );
  }
  
  // 检查鼠标是否移动到当前导航项的子元素
  function isMouseInCurrentNavItem(relatedTarget, currentItem) {
    return relatedTarget && currentItem && currentItem.contains(relatedTarget);
  }
  
  // 检查鼠标是否移动到下拉菜单的子元素
  function isMouseInCurrentDropdown(relatedTarget, currentDropdown) {
    return relatedTarget && currentDropdown && currentDropdown.contains(relatedTarget);
  }
  
  // 为每个导航项添加事件监听
  navItems.forEach((item, index) => {
    const dropdown = item.querySelector('.mt-navigation__dropdown');
    const tabs = item.querySelectorAll('.mt-navigation__dropdown-tab');
    const menuContents = item.querySelectorAll('.mt-navigation__dropdown-menu-content');
    const navLink = item.querySelector('.mt-navigation__nav-link');
    
    // 检查是否有下拉菜单或有子菜单
    const hasDropdown = dropdown !== null;
    const hasSubMenu = item.querySelector('.mt-navigation__dropdown-container') !== null;
    
    if (hasDropdown || hasSubMenu) {
      
      // 鼠标进入导航链接时显示下拉菜单
      if (navLink) {
        navLink.addEventListener('mouseenter', function(e) {
          const itemText = navLink.textContent;
          
          clearAllTimeouts();
          
          // 如果快速切换到不同项目，减少延迟避免闪烁
          if (lastHoveredItem && lastHoveredItem !== item) {
            // 隐藏之前的下拉菜单
            if (currentDropdown && currentDropdown !== dropdown) {
              hideAllDropdowns();
            }
            
            // 减少延迟时间，避免闪烁
            hoverTimeout = setTimeout(() => {
              isMouseInNavItem = true;
              lastHoveredItem = item;
              
              if (dropdown) {
                showDropdown(dropdown, item);
                currentDropdown = dropdown;
                isMouseInDropdown = false;
              }
            }, 20);
            return;
          }
          
          // 直接处理悬停逻辑
          isMouseInNavItem = true;
          lastHoveredItem = item;
          
          // 如果有其他下拉菜单正在显示，先隐藏它
          if (currentDropdown && currentDropdown !== dropdown) {
            hideAllDropdowns();
          }
          
            // 显示当前下拉菜单
           if (dropdown) {
             // 如果当前下拉菜单已经显示，不需要重新显示
             if (currentDropdown === dropdown && dropdown.style.visibility === 'visible') {
               return;
             }
             
             // 再次确保没有其他下拉菜单显示
             hideAllDropdowns();
             
             showDropdown(dropdown, item);
             currentDropdown = dropdown;
             // 重置下拉菜单状态，确保鼠标进入下拉菜单时能正确设置
             isMouseInDropdown = false;
           }
        });
        
        // 鼠标离开导航链接时隐藏下拉菜单
        navLink.addEventListener('mouseleave', function(e) {
          const itemText = navLink.textContent;
          
          const relatedTarget = e.relatedTarget;
          
          // 检查鼠标是否移动到当前下拉菜单的子元素
          if (dropdown && isMouseInCurrentDropdown(relatedTarget, dropdown)) {
            return;
          }
          
          // 如果鼠标离开了导航链接且没有移动到下拉菜单，延迟隐藏下拉菜单
          isMouseInNavItem = false;
          
          // 减少延迟时间，避免闪烁
          dropdownTimeout = setTimeout(() => {
            if (!isMouseInDropdown && !isMouseInNavItem) {
              if (dropdown) {
                hideDropdown(dropdown, item);
                currentDropdown = null;
                lastHoveredItem = null;
              }
            }
          }, 50);
        });
      }
      
      // 下拉菜单的鼠标事件
      if (dropdown) {
        dropdown.addEventListener('mouseenter', function(e) {
          isMouseInDropdown = true;
          clearTimeout(dropdownTimeout);
        });
        
        dropdown.addEventListener('mouseleave', function(e) {
          const relatedTarget = e.relatedTarget;
          
          // 检查鼠标是否移动到当前导航项的导航链接
          const navLink = item.querySelector('.mt-navigation__nav-link');
          if (navLink && (relatedTarget === navLink || navLink.contains(relatedTarget))) {
            return;
          }
          
          // 如果鼠标离开了下拉菜单且没有移动到导航链接，立即隐藏下拉菜单
          isMouseInDropdown = false;
          hideDropdown(dropdown, item);
          currentDropdown = null;
          lastHoveredItem = null;
        });
      }
      
      // 标签切换功能
      if (tabs.length > 0) {
        tabs.forEach((tab, index) => {
          // 点击切换
          tab.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            switchTab(tab, index);
          });
          
          // 鼠标悬停切换
          tab.addEventListener('mouseenter', function(e) {
            e.preventDefault();
            e.stopPropagation();
            switchTab(tab, index);
          });
        });
        
        // 标签切换函数
        function switchTab(activeTab, tabIndex) {
          
          // 移除所有活动状态
          tabs.forEach(t => {
            t.classList.remove('mt-navigation__dropdown-tab--active', 'mt-navigation__dropdown-tab--hover');
          });
          menuContents.forEach(content => content.classList.remove('mt-navigation__dropdown-menu-content--active'));
          
          // 添加当前活动状态
          activeTab.classList.add('mt-navigation__dropdown-tab--active', 'mt-navigation__dropdown-tab--hover');
          if (menuContents[tabIndex]) {
            menuContents[tabIndex].classList.add('mt-navigation__dropdown-menu-content--active');
          }
          
          // 切换产品内容
          const productsContents = dropdown.querySelectorAll('.mt-navigation__dropdown-products-content');
          productsContents.forEach(content => {
            content.classList.remove('mt-navigation__dropdown-products-content--active');
          });
          
          const targetTab = tabIndex + 1;
          
          // 查找对应的产品内容
          const activeProductsContent = dropdown.querySelector(`.mt-navigation__dropdown-products-content[data-tab="${targetTab}"]`);
          
          if (activeProductsContent) {
            activeProductsContent.classList.add('mt-navigation__dropdown-products-content--active');
          } else {
            // 如果没有找到对应的产品内容，尝试查找第一个可用的
            const firstProductsContent = dropdown.querySelector('.mt-navigation__dropdown-products-content');
            if (firstProductsContent) {
              firstProductsContent.classList.add('mt-navigation__dropdown-products-content--active');
            }
          }
          
          // 同时处理三级菜单的产品内容
          const subProductsContents = dropdown.querySelectorAll(`.mt-navigation__dropdown-products-content[data-tab="${targetTab}"][data-sub-tab]`);
          subProductsContents.forEach(content => {
            content.classList.remove('mt-navigation__dropdown-products-content--active');
          });
        }
        
        // 标签鼠标离开事件
        tabs.forEach((tab, index) => {
          tab.addEventListener('mouseleave', function(e) {
            // 如果不是当前激活的标签，移除hover状态
            if (!tab.classList.contains('mt-navigation__dropdown-tab--active')) {
              tab.classList.remove('mt-navigation__dropdown-tab--hover');
            }
          });
        });
        
                      // 处理三级菜单项的鼠标悬停事件
              const menuItems = dropdown.querySelectorAll('.mt-navigation__dropdown-menu-item[data-sub-tab]');
              
              menuItems.forEach((menuItem, index) => {
                menuItem.addEventListener('mouseenter', function(e) {
                  const subTab = this.getAttribute('data-sub-tab');
                  const parentTab = this.closest('.mt-navigation__dropdown-menu-content').getAttribute('data-tab');
                  
                  clearTimeout(dropdownTimeout);
                  
                  // 隐藏所有产品内容（包括产品组合）
                  const allProductsContents = dropdown.querySelectorAll('.mt-navigation__dropdown-products-content');
                  allProductsContents.forEach((content, i) => {
                    content.classList.remove('mt-navigation__dropdown-products-content--active');
                  });
            
            // 显示对应的三级菜单产品内容
            const targetProductsContent = dropdown.querySelector(`.mt-navigation__dropdown-products-content[data-tab="${parentTab}"][data-sub-tab="${subTab}"]`);
            if (targetProductsContent) {
              targetProductsContent.classList.add('mt-navigation__dropdown-products-content--active');
            } else {
              // 尝试查找没有 data-sub-tab 的产品内容（二级菜单的情况）
              const fallbackProductsContent = dropdown.querySelector(`.mt-navigation__dropdown-products-content[data-tab="${parentTab}"]:not([data-sub-tab])`);
              if (fallbackProductsContent) {
                fallbackProductsContent.classList.add('mt-navigation__dropdown-products-content--active');
              }
            }
          });
          
          menuItem.addEventListener('mouseleave', function(e) {
            // 检查鼠标是否移动到了其他菜单项
            const relatedTarget = e.relatedTarget;
            if (relatedTarget && (relatedTarget.closest('.mt-navigation__dropdown-menu-item') || relatedTarget.closest('.mt-navigation__dropdown'))) {
              return;
            }
            
            // 如果鼠标离开了菜单区域，延迟处理
            setTimeout(() => {
              if (!isMouseInDropdown) {
                // 保持下拉菜单打开
              }
            }, 50);
          });
        });
        
        // 初始化：确保第一个标签是激活状态
        if (tabs.length > 0) {
          switchTab(tabs[0], 0);
        }
      }
    }
  });
  
  // 汉堡菜单功能
  const hamburger = document.querySelector('.mt-navigation__hamburger');
  const mobileMenu = document.querySelector('.mt-navigation__mobile-menu');
  const mobileMenuClose = document.querySelector('.mt-navigation__mobile-menu-close');
  const mobileOverlay = document.querySelector('.mt-navigation__mobile-overlay');
  
  function openMobileMenu() {
    mobileMenu.classList.add('active');
    hamburger.classList.add('active');
    hamburger.style.display = 'none';
    if (mobileMenuClose) {
      mobileMenuClose.style.display = 'flex';
    }
    // 不阻止页面滚动，允许用户正常滚动页面
  }
  
  function closeMobileMenu() {
    mobileMenu.classList.remove('active');
    hamburger.classList.remove('active');
    hamburger.style.display = 'flex';
    if (mobileMenuClose) {
      mobileMenuClose.style.display = 'none';
    }
  }
  
  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', function() {
      openMobileMenu();
    });
  }
  
  if (mobileMenuClose) {
    mobileMenuClose.addEventListener('click', function() {
      closeMobileMenu();
    });
  }
  

  
  // 点击页面其他区域关闭菜单
  document.addEventListener('click', function(e) {
    if (mobileMenu && mobileMenu.classList.contains('active')) {
      const isClickInsideMenu = mobileMenu.contains(e.target);
      const isClickOnHamburger = hamburger && hamburger.contains(e.target);
      
      if (!isClickInsideMenu && !isClickOnHamburger) {
        closeMobileMenu();
      }
    }
  });
  
  // 移动端下拉菜单功能
  const mobileDropdowns = document.querySelectorAll('.mt-navigation__mobile-menu-dropdown');
  mobileDropdowns.forEach(dropdown => {
    const dropdownButton = dropdown.querySelector('.mt-navigation__mobile-menu-link--has-dropdown');
    
    if (dropdownButton) {
      dropdownButton.addEventListener('click', function(e) {
        e.preventDefault();
        dropdown.classList.toggle('active');
      });
    }
  });
  
  // 移动端三级菜单功能
  const mobileSubDropdowns = document.querySelectorAll('.mt-navigation__mobile-menu-sub-dropdown');
  mobileSubDropdowns.forEach(subDropdown => {
    const subDropdownButton = subDropdown.querySelector('.mt-navigation__mobile-menu-sub-dropdown-btn');
    
    if (subDropdownButton) {
      subDropdownButton.addEventListener('click', function(e) {
        e.preventDefault();
        subDropdown.classList.toggle('active');
      });
    }
  });
  
  // 搜索功能
  const searchBtn = document.querySelector('.mt-navigation__icon-btn[aria-label="Search"]');
  const searchModal = document.querySelector('.mt-navigation__search');
  
  if (searchBtn && searchModal) {
    const searchSummary = searchModal.querySelector('summary');
    
    if (searchSummary) {
      searchBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        // 触发summary的点击事件来打开模态框
        searchSummary.click();
        
        // 聚焦到搜索输入框
        setTimeout(() => {
          const searchInput = searchModal.querySelector('input[type="search"]');
          if (searchInput) {
            searchInput.focus();
          }
        }, 100);
      });
    }
  }
  
  // 购物车按钮点击事件 - 打开购物车抽屉
  const cartIconBubble = document.getElementById('cart-icon-bubble');
  if (cartIconBubble) {
    cartIconBubble.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      // 调用全局的购物车抽屉打开函数
      if (typeof window.openCartDrawer === 'function') {
        window.openCartDrawer();
      } else if (typeof window.CartDrawer !== 'undefined' && typeof window.CartDrawer.open === 'function') {
        window.CartDrawer.open();
      } else {
        console.warn('购物车抽屉功能未找到');
        // 如果没有购物车抽屉，允许默认行为（跳转到购物车页面）
        window.location.href = '/cart';
      }
    });
  }
  
  // 购物车数量更新函数
  function updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartCount = document.querySelector('.mt-navigation__cart-count');
        const cartIcon = document.getElementById('cart-icon-bubble');
        
        if (cart.item_count > 0) {
          // 显示购物车数量
          if (cartCount) {
            cartCount.textContent = cart.item_count;
            cartCount.style.display = 'flex';
          } else if (cartIcon) {
            // 如果购物车数量元素不存在，创建它
            const newCartCount = document.createElement('span');
            newCartCount.className = 'mt-navigation__cart-count';
            newCartCount.textContent = cart.item_count;
            cartIcon.appendChild(newCartCount);
          }
        } else {
          // 隐藏购物车数量
          if (cartCount) {
            cartCount.style.display = 'none';
          }
        }
      })
      .catch(error => {
        console.error('Failed to update cart count:', error);
      });
  }
  
  // 导出全局更新函数，供其他脚本调用
  window.updateNavigationCartCount = updateCartCount;
  
  // 初始化购物车数量
  updateCartCount();
  
  // 监听购物车更新事件
  document.addEventListener('cart:updated', updateCartCount);
  if (typeof window.PUB_SUB_EVENTS !== 'undefined') {
    document.addEventListener(window.PUB_SUB_EVENTS.cartUpdate, updateCartCount);
  }
  

  
  // 语言切换功能 - 支持Translate & Adapt插件
  const languageSelectorItems = document.querySelectorAll('.mt-navigation__mobile-menu-dropdown-item[data-value]');
  const languageForm = document.getElementById('NavigationLanguageForm');
  
  languageSelectorItems.forEach(item => {
    item.addEventListener('click', function(e) {
      e.preventDefault();
      
      const languageCode = this.getAttribute('data-value');
      const localeCode = this.getAttribute('data-locale');
      
      // 检查是否有Translate & Adapt插件
      const enableTranslateAdapt = document.querySelector('[data-translate-adapt-enabled]')?.getAttribute('data-translate-adapt-enabled') === 'true';
      
      if (enableTranslateAdapt && window.Shopify && window.Shopify.translate) {
        // 使用Translate & Adapt插件的方法
        try {
          window.Shopify.translate.changeLanguage(localeCode || languageCode);
        } catch (error) {
          // 回退到标准方法
          const localeInput = languageForm.querySelector('input[name="locale_code"]');
          if (localeInput) {
            localeInput.value = languageCode;
            languageForm.submit();
          }
        }
      } else {
        // 标准Shopify本地化方法
        const localeInput = languageForm.querySelector('input[name="locale_code"]');
        if (localeInput) {
          localeInput.value = languageCode;
          languageForm.submit();
        }
      }
    });
  });
});